import { type AdminCompanySelectDto, CompanyType } from '@@types/api.types';
import { createColumnConfigHelper } from '@components/data-table-filter/core/filters';
import { COMPANY_TYPE_LABELS } from '@utils/company.util';
import { BuildingIcon, TagIcon, TrashIcon } from 'lucide-react';

const dtf = createColumnConfigHelper<AdminCompanySelectDto>();

export const columnsConfig = [
  dtf
    .option()
    .id('type')
    .accessor((row) => row.type)
    .displayName('Type')
    .icon(BuildingIcon)
    .options([
      { label: COMPANY_TYPE_LABELS[CompanyType.COMMERCIAL], value: CompanyType.COMMERCIAL },
      { label: COMPANY_TYPE_LABELS[CompanyType.INTELLIGENCE], value: CompanyType.INTELLIGENCE },
      { label: COMPANY_TYPE_LABELS[CompanyType.RESEARCH], value: CompanyType.RESEARCH },
      { label: COMPANY_TYPE_LABELS[CompanyType.RESEARCH_PROJECT], value: CompanyType.RESEARCH_PROJECT },
    ])
    .build(),
  dtf
    .multiOption()
    .id('companyTags')
    .accessor(() => [])
    .displayName('Access Control Tags')
    .icon(TagIcon)
    .build(),
  dtf
    .option()
    .id('deleted')
    .accessor((row) => (row.deleted ? 'true' : 'false'))
    .displayName('Deleted')
    .icon(TrashIcon)
    .options([
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' },
    ])
    .build(),
] as const;
